var render = function render(){var _vm=this,_c=_vm._self._c;return _c('no-ssr',[_c('div',{staticClass:"GlobalSlot"},[_c('DownloadInterceptDialog'),_vm._v(" "),_c('PicPackagePayModal'),_vm._v(" "),_c('ProfitModal',{ref:"ProfitModal",on:{"navigatorToPay":_vm.navigatorToPay,"limitTag":_vm.limitTag}}),_vm._v(" "),_c('SurveyUserDialog',{ref:"SurveyUserDialog"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }